module.exports = __webpack_public_path__ + "resources/img/img_alyac1_m_en.b27aac7227d938b6c1998bc76fc0d7b8.png";